import { Component, ElementRef, EventEmitter, Output } from '@angular/core';
import { MyMbtiGuestQuizReport, MyMbtiGuestQuizReportPaginatedListResponse } from 'src/app/interfaces/mbti';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { QuizService } from 'src/app/services/quiz/quiz.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { MbtiService } from './../../../../services/mbti/mbti.service';
import { QuizReportSelectorComponent } from './../quiz-report-selector.component';

@Component({
  selector: 'app-guest-quiz-report-selector',
  templateUrl: './guest-quiz-report-selector.component.html',
  styleUrls: ['../quiz-report-selector.component.scss'],
})
export class GuestQuizReportSelectorComponent extends QuizReportSelectorComponent {
  
  @Output() selected = new EventEmitter<MyMbtiGuestQuizReport>();
  title = '대표 퀴즈 설정';
  description = '내 타입스 프로필에 표시될 퀴즈입니다.<br>대표 퀴즈를 설정하지 않으면 가장 최근 퀴즈가 표시됩니다.';
  quizReportList: MyMbtiGuestQuizReport[] = [];
  selectedQuizReport: MyMbtiGuestQuizReport | undefined;

  constructor(
    protected quizService: QuizService,
    protected snackbarService: SnackbarService,
    protected modalService: ModalService,
    protected elementRef: ElementRef,
    private mbtiService: MbtiService,
    protected logService: LogService,
  ) {
    super(quizService, snackbarService, modalService, elementRef, logService);
  }

  onSelected(quizReport: MyMbtiGuestQuizReport): void {
    this.selectedQuizReport = quizReport;
    if (this.hideButton) {
      this.onClickButton();
    }
  }

  protected getQuizReportList(): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.mbtiService.getMyMbtiGuestQuizReportList(this.cursor)
      .subscribe((res: MyMbtiGuestQuizReportPaginatedListResponse) => {
        this.quizReportList.push(...res?.data ?? []);
        this.cursor = res.cursor ?? null;
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      });
  }
}